import { RootState } from 'editor/src/store/index';

import getFirstGridElement from './getFirstGridElement';

const getIsWeekNumberChecked = (state: RootState) => !getFirstGridElement(state)?.grid.hideWeekNum;

export default getIsWeekNumberChecked;
